export const buildAppHeaderTitle = (userName) => {
  const normalizedName = String(userName || "").trim();
  return normalizedName ? `ClinicChat · ${normalizedName}` : "ClinicChat";
};

export const shouldShowDevBadge = (environment) =>
  environment === "development";
